/** Lo que devuelve la API del despliegue estratégico. */

export const ESTADOS_ETAPA = ["PENDIENTE", "EN_PROGRESO", "COMPLETADA"] as const
export type EstadoEtapa = (typeof ESTADOS_ETAPA)[number]

export const NOMBRE_ESTADO: Record<EstadoEtapa, string> = {
  PENDIENTE: "Pendiente",
  EN_PROGRESO: "En progreso",
  COMPLETADA: "Completada",
}

/**
 * ⚠ **Sólo `COMPLETADA` cuenta para el avance.** «En progreso» no aporta un medio
 * punto: contarlo obligaría a decidir cuánto vale «en progreso», y esa cifra la
 * pondría cada quien a ojo. Un hito o está hecho o no lo está.
 */
export const TONO_ESTADO: Record<EstadoEtapa, "neutro" | "aviso" | "exito"> = {
  PENDIENTE: "neutro",
  EN_PROGRESO: "aviso",
  COMPLETADA: "exito",
}

export type Etapa = {
  id: number
  objetivo_id: number
  titulo: string
  meta: string | null
  fecha: string | null
  estado: EstadoEtapa
  orden: number
}

export type Objetivo = {
  id: number
  pilar_id: number
  enunciado: string
  indicador: string | null
  linea_base: string | null
  meta: string | null
  unidad: string | null
  responsable_cargo_id: number | null
  responsable: string | null
  fecha_inicio: string | null
  fecha_fin: string | null
  orden: number
  /** Derivado de las etapas por el servidor. Nunca se manda. */
  avance: number
  /** Lo decide el reloj del servidor. Ver la cabecera de `Estrategia.tsx`. */
  vencido: boolean
  etapas: Etapa[]
}

export type Pilar = {
  id: number
  origen: "VISION" | "MISION"
  titulo: string
  descripcion: string | null
  orden: number
  avance: number
  objetivos: Objetivo[]
}

export type Despliegue = { avance: number; pilares: Pilar[] }
